// Real portfolio media (client-provided works), served from /public/works
// Categories were derived from visual analysis of each photo.
const PHOTO_CATEGORY = {
  1: "corniches", 10: "corniches",
  3: "colonnes", 7: "colonnes", 9: "colonnes", 13: "colonnes", 25: "colonnes",
  2: "moulures", 4: "moulures", 5: "moulures", 6: "moulures", 11: "moulures",
  12: "moulures", 26: "moulures", 31: "moulures", 38: "moulures", 39: "moulures",
  40: "moulures", 41: "moulures", 42: "moulures", 43: "moulures",
  8: "interieurs", 14: "interieurs", 15: "interieurs", 16: "interieurs",
  17: "interieurs", 18: "interieurs", 19: "interieurs", 20: "interieurs",
  21: "interieurs", 23: "interieurs", 24: "interieurs", 27: "interieurs",
  29: "interieurs", 30: "interieurs", 32: "interieurs", 33: "interieurs",
  34: "interieurs", 35: "interieurs", 36: "interieurs", 37: "interieurs", 44: "interieurs",
};

const PHOTO_IDS = [
  1, 4, 12, 13, 14, 15, 16, 17, 18, 20, 21,
  23, 24, 26, 27, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42,
  43, 45,
];

const VIDEO_IDS = [1, 2, 3, 4, 5, 6, 7, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24];

export const PHOTO_CATEGORIES = ["all", "corniches", "moulures", "colonnes", "interieurs"];

export const PHOTOS = PHOTO_IDS.map((id) => ({
  id: `photo-${id}`,
  src: `/works/photos/photo_${id}.jpg`,
  category: PHOTO_CATEGORY[id] || "interieurs",
}));

export const VIDEOS = VIDEO_IDS.map((id) => ({
  id: `video-${id}`,
  src: `/works/videos/video_${id}.mp4`,
}));

// Representative thumbnails for service cards (real work photos)
export const SERVICE_IMAGES = {
  corniches: "/works/photos/photo_1.jpg",
  rosaces: "/works/photos/photo_17.jpg",
  colonnes: "/works/photos/photo_12.jpg",
  moulures: "/works/photos/photo_18.jpg",
  panneaux: "/works/photos/photo_24.jpg",
  decor: "/works/photos/photo_31.jpg",
  restauration: "/works/photos/photo_34.jpg",
};

export const ABOUT_IMAGE = "/works/photos/photo_37.jpg";
